// @ts-nocheck
const datadogLogger = require('@datadog/browser-logs');
const configurationManager = require('../config/configurationManager');
const stateManager = require('../state/stateManager');
const stringUtil = require('../string/stringUtil');
const guidUtil = require('../guid/guidUtil');
const commonUtility = require('../domain/commonUtility');
const terminalUtility = require('../domain/terminalUtility');


var ddLogger;
var sessionId = guidUtil.generateGuid();

module.exports.initializeDatadog = function()
{
    if (ddLogger != null)
        return;

    if(stringUtil.isStringNullOrEmpty(configurationManager.getConfig().dataDogClientToken) || stringUtil.isStringNullOrEmpty(configurationManager.getConfig().dataDogSite))
        return;

    datadogLogger.datadogLogs.init({
        clientToken: configurationManager.getConfig().dataDogClientToken,
        site: configurationManager.getConfig().dataDogSite,
        env: getEnvironment(),
        service: "RMS.APP.POS",
        version: configurationManager.getConfig().version,
        forwardErrorsToLogs: true,
        sessionSampleRate: 100,
        beforeSend: (log) => 
        {
            /*// discard Ably Errors
            if (log.http && log.http.url.toLocaleUpperCase.startsWith("XHR error GET https://rest.ably.io".toLocaleLowerCase())) 
            {
                return false
            }*/

            return true;
        },
    });

    ddLogger = datadogLogger.datadogLogs.logger;
}

module.exports.resetGlobalContext = function()
{
    this.initializeDatadog();
    if (ddLogger == null)  return;

    datadogLogger.datadogLogs.setGlobalContext(
                                                { 
                                                    env: getEnvironment(), 
                                                    shellType: stateManager.getStore().getState().shellType,
                                                    renderingMode: stateManager.getStore().getState().renderingMode,
                                                    version: configurationManager.getConfig().version,
                                                    sessionId: sessionId
                                                });

    
}

module.exports.attachOrgToGlobalContext = function()
{
    this.initializeDatadog();
    if (ddLogger == null)  return;

    datadogLogger.datadogLogs.setGlobalContext(
        { 
            env: getEnvironment(), 
            shellType: stateManager.getStore().getState().shellType,
            renderingMode: stateManager.getStore().getState().renderingMode,
            version: configurationManager.getConfig().version,
            sessionId: sessionId,

            franchisorId: commonUtility.getFranchisor().id, 
            franchisorCode: commonUtility.getFranchisor().code, 
            franchisorName: commonUtility.getFranchisor().name, 

            franchiseeId: commonUtility.getFranchisee().id, 
            franchiseeCode: commonUtility.getFranchisee().code, 
            franchiseeName: commonUtility.getFranchisee().name, 

            propertyId: commonUtility.getProperty().id, 
            propertyCode: commonUtility.getProperty().code, 
            propertyName: commonUtility.getProperty().name, 

            terminalCode: terminalUtility.getTerminalCode(),
        });
}

module.exports.info = function(message, messageContext = {}, tag)
{
    try
    {
        messageContext = initializeMessageContext(messageContext, tag);

        console.info(message);
        if (ddLogger != null) ddLogger.info(message, messageContext);
    }
    catch(error){}
}

module.exports.warn = function(message, messageContext = {}, error, tag)
{
    try
    {
        messageContext = initializeMessageContext(messageContext, tag);
        if (error != null)
        {
            messageContext.errorMessage = error.toString();
            message.errorStack = error.stack;
        }

        console.warn(message);
        if (ddLogger != null) ddLogger.warn(message, messageContext);
    }
    catch(error){}
}

module.exports.error = function(message, messageContext, error, tag)
{
    try
    {
        messageContext = initializeMessageContext(messageContext, tag);
        
        console.error(message);
        if (ddLogger != null) ddLogger.error(message, messageContext, error);
    }
    catch(error){}
}

module.exports.metrics = function (metricName, metricValue, metricDescription, messageContext)
{
    messageContext = initializeMessageContext(messageContext);
    messageContext.loggingType = "metrics";
    messageContext.metricName = metricName.toUpperCase();
    messageContext.metricValue = metricValue * 1;
    messageContext.metricDescription = metricDescription;

    var message = `Recording metric (${metricName})`;
    console.info(message);
    if (ddLogger != null) ddLogger.info(message, messageContext);
}

module.exports.usage = function (featureName, featureDescription, messageContext)
{
    messageContext = initializeMessageContext(messageContext);
    messageContext.loggingType = "features";
    messageContext.featureName = featureName;
    messageContext.featureCount = 1;
    messageContext.featureDescription = featureDescription;

    var message = `Recording feature (${featureName})`;
    console.info(message);
    if (ddLogger != null) ddLogger.info(message, messageContext);
}

function initializeMessageContext(messageContext, tag)
{
    if (messageContext == null)
        messageContext = {};

    messageContext.loggingDateTime = Date.now();
    messageContext.loggingType = "logging";
    messageContext.tag = tag;
    return messageContext;
}



function getEnvironment()
{
    var env = configurationManager.getConfig().environment;
    if (stringUtil.areStringSame(env, "ukwest"))
        env = "production";
        
    return env;
}
